import React from 'react'
import { Provider } from 'react-redux'
import { hot } from 'react-hot-loader'
import LocaleLoader from 'containers/LocaleLoader'
import CatastrophicErrorDisplay from 'components/CatastrophicErrorDisplay'

import createStore from 'store/createStore.js'

const { store } = createStore()

export class App extends React.PureComponent {
  state = {
    error: undefined,
  }

  componentDidCatch(error, _info) {
    this.setState({ error })
  }

  render() {
    const {
      error,
    } = this.state
    if(error) {
      return (
        <CatastrophicErrorDisplay
          title={(
            <>
              <div style={{ fontSize: '1.75em', lineHeight: 1 }}><span role="img" aria-label="ouchie">🤕</span></div>
              <div>Error</div>
            </>
          )}
          description="An error ocurred."
          errors={process.env.NODE_ENV === 'development' ? [error] : null}
        />

      )
    }
    const { children } = this.props
    return (
      <Provider store={store}>
        <LocaleLoader>
          {children}
        </LocaleLoader>
      </Provider>
    )
  }
}

export default hot(module)(App)
